<template>
    <div class="input__container">
        <p v-if="title">{{ title }}</p>
        <input 
            v-if="type === 'date' || type === 'email' || type === 'number'"
            :type="type" 
            :value="modelValue" 
            :placeholder="placeholder" 
            :disabled="disabled"
            @input="input($event)"
            @keypress="$emit('keypress', $event)" 
        />
        <input
            v-else
            :type="type" 
            :value="modelValue"
            :placeholder="placeholder" 
            :disabled="disabled"
            v-mask="mask(maskType)"
            @input="input($event)" 
        />
        <span v-if="error">{{ error }}</span>

        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            type: String,
            maskType: String,
            modelValue: String,
            placeholder: String,
            disabled: Boolean,
            title: String,
            error: String,
        },
        emits: ['update:modelValue', 'input', 'keypress'],
        methods: {
            input(e) {
                this.$emit('update:modelValue', e.target.value)
                this.$emit('input', e.target.value)
            },
            mask(type) {
                if (type === 'tel') {
                    return {
                        mask: '+7 (FD#) ###-##-##',
                        tokens: {
                            F: { pattern: /[3489]/ },
                            D: { pattern: this.modelValue?.[4] == '8' ? /[0-8]/ : /\d/ },
                            '#': { pattern: /\d/ },
                        }
                    }    
                }
                if (type === 'passport-serial') {
                    return {
                        mask: '####',
                        tokens: {
                            '#': { pattern: /\d/ },
                        }
                    }    
                }
                if (type === 'passport-number') {
                    return {
                        mask: '######',
                        tokens: {
                            '#': { pattern: /\d/ },
                        }
                    }    
                }
                if (type === 'passport-code') {
                    return {
                        mask: '###-###',
                        tokens: {
                            '#': { pattern: /\d/ },
                        }
                    }    
                }
                return {
                    mask: '#'.repeat(200),
                    tokens: {
                        '#': { pattern: /./ },
                    },
                }    
               
            }
        }
    }
</script>

<style lang="scss" scoped>
.input__container {
    position: relative;
    display: flex;
    flex-direction: column;

    input {
        width: 100%;
        appearance: none;

        &:disabled {
            background-color: transparent;
        }
    }
}

</style>